import React from 'react';

const WorkTime = ({ currentLanguage = 'EN' }) => {
  const content = {
    EN: {
      title: "Opening Hours",
      subtitle: "Visit Us During These Hours",
      location: {
        title: "Our Location",
        address: "104 Holly St",
        city: "McGehee, Arkansas 71654",
        phone: "+1 (601) 504-4422",
        email: "info@studioglow.com"
      },
      hours: [
        { day: "Monday", time: "9:00 AM - 7:00 PM", isOpen: true },
        { day: "Tuesday", time: "9:00 AM - 7:00 PM", isOpen: true },
        { day: "Wednesday", time: "9:00 AM - 7:00 PM", isOpen: true },
        { day: "Thursday", time: "9:00 AM - 7:00 PM", isOpen: true },
        { day: "Friday", time: "9:00 AM - 8:00 PM", isOpen: true },
        { day: "Saturday", time: "10:00 AM - 8:00 PM", isOpen: true },
        { day: "Sunday", time: "10:00 AM - 6:00 PM", isOpen: true }
      ],
      note: "Walk-ins welcome, but appointments are recommended",
      bookButton: "Book Appointment",
      contactButton: "Contact Us"
    }
  };

  const currentContent = content.EN;

  return (
    <>
      <style>{`
        .font-inter {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }
      `}</style>

      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className={`text-3xl md:text-4xl font-bold text-gray-900 mb-3 font-inter`}>
              {currentContent.title}
            </h2>
            <p className={`text-lg text-gray-600 font-inter`}>
              {currentContent.subtitle}
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            
            {/* Opening Hours */}
            <div className="bg-white rounded-lg shadow-md p-6 md:p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#B08B71] bg-opacity-10 rounded-lg flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-[#B08B71]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className={`text-2xl font-bold text-gray-900 font-inter`}>
                  {currentContent.title}
                </h3>
              </div>

              <div className="space-y-3">
                {currentContent.hours.map((schedule, index) => (
                  <div 
                    key={index}
                    className="flex justify-between items-center py-3 border-b border-gray-200 last:border-b-0"
                  >
                    <span className={`font-semibold text-gray-900 font-inter`}>
                      {schedule.day}
                    </span>
                    <div className="flex items-center">
                      {schedule.isOpen && (
                        <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                      )}
                      <span className={`text-gray-600 font-inter`}>
                        {schedule.time}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-6 p-4 bg-[#B08B71] bg-opacity-10 rounded-lg border border-[#B08B71] border-opacity-20">
                <p className={`text-sm text-gray-700 font-inter`}>
                  <span className="font-semibold text-[#B08B71]">ℹ️ </span>
                  {currentContent.note}
                </p>
              </div>
            </div>

            {/* Contact Information */}
            <div className="bg-white rounded-lg shadow-md p-6 md:p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-[#B08B71] bg-opacity-10 rounded-lg flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-[#B08B71]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <h3 className={`text-2xl font-bold text-gray-900 font-inter`}>
                  {currentContent.location.title}
                </h3>
              </div>

              <div className="space-y-4">
                {/* Address */}
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <p className={`font-semibold text-gray-900 font-inter`}>
                      {currentContent.location.address}
                    </p>
                    <p className={`text-gray-600 font-inter`}>
                      {currentContent.location.city}
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center mr-3">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <a 
                    href="tel:+16015044422"
                    className={`font-semibold text-[#B08B71] hover:text-[#9c7a62] font-inter`}
                  >
                    {currentContent.location.phone}
                  </a>
                </div>

                {/* Email */}
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center mr-3">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <a 
                    href="mailto:info@studioglow.com"
                    className={`font-semibold text-[#B08B71] hover:text-[#9c7a62] font-inter`}
                  >
                    {currentContent.location.email}
                  </a>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="mt-6 bg-gray-100 rounded-lg h-48 flex items-center justify-center border border-gray-200">
                <div className="text-center">
                  <svg className="w-12 h-12 text-gray-400 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                  </svg>
                  <p className={`text-gray-500 text-sm font-inter`}>
                    Map View
                  </p>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="mt-6 grid grid-cols-2 gap-3">
                <button className={`bg-[#B08B71] hover:bg-[#9c7a62] text-white py-3 rounded-lg font-semibold font-inter`}>
                  {currentContent.bookButton}
                </button>
                <button className={`bg-gray-200 hover:bg-gray-300 text-gray-700 py-3 rounded-lg font-semibold font-inter`}>
                  {currentContent.contactButton}
                </button>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 bg-white rounded-lg shadow-md p-6 text-center">
            <p className={`text-gray-700 font-inter`}>
              💬 Have questions? Feel free to call us or visit during our opening hours!
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default WorkTime;